import React from 'react'
import  SplitText  from '../animation/SplitText'
import { useTranslation } from "react-i18next";
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Certificates from './Certificates';
import Contact from './Contact';
function LandingPage() {

      const { t } = useTranslation("translation");
  return (
        <div className="flex flex-col gap-10 m-10 min-h-screen">
          <div className="info flex flex-col gap-3 items-center font-bold text-2lg">
            <div className="image">
                <img className='rounded-[12px] ' src="/presonal.svg" alt="logo" width={130}
                height={100}/>
              
            </div>
            <h1 className="text-[var(--color-main)] text-2xl">
              {t("main.name")}{" "}
            </h1>
            <SplitText
              text={t("main.dev")}
              className="text-2xl font-semibold text-center"
              delay={100}
              duration={0.6}
              ease="power3.out"
              splitType="chars"
              from={{ opacity: 0, y: 40 }}
              to={{ opacity: 1, y: 0 }}
              threshold={0.1}
              rootMargin="-100px"
              textAlign="center"
              direction="ltr"
            />
          </div>
          <About/>
          <Skills/>
          <Projects/>
          <Certificates/>
          <Contact/>

        </div>
  )
}

export default LandingPage
